import React from 'react';
import PropTypes from 'prop-types';
import { StyledTrack, StyledIndicator } from './styles.js';

export const ProgressBar = ({ currentStep, totalSteps, labelText }) => {
  const progress =
    currentStep > totalSteps ? 100 : (currentStep / totalSteps) * 100;
  return (
    <StyledTrack role="progressbar" aria-label={labelText}>
      <StyledIndicator progress={progress} />
    </StyledTrack>
  );
};

ProgressBar.displayName = 'ProgressBar';

ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  labelText: PropTypes.string.isRequired,
};
